export default __webpack_public_path__ + "static/media/move-and-resize-fitb.8d8d8e7d.gif";